interface ToastProps {
  message: string | null;
}

export default function Toast({ message }: ToastProps) {
  if (!message) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 animate-fade-in">
      <div className="flex items-center gap-2.5 rounded-full border border-foreground-800 bg-foreground-950 px-4 py-2.5 text-sm text-background-50">
        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
          <i className="ri-check-line text-xs" />
        </span>
        <span className="leading-snug">{message}</span>
      </div>
    </div>
  );
}